import AuthService from '../../service';
const news = {
  getNews(page,search,sort_date,sort_column){
    return AuthService.get(`/about/news?page=${page}&search=${search}&sort_date=${sort_date}&sort_column=${sort_column}`);
  },
  showNews(id){
    return AuthService.get(`/about/news/${id}`);
  },
  createNews(data){
    return AuthService.post(`/about/news`,data);
  },
  updateNews(id,data){
    return AuthService.put(`/about/news/${id}`,data);
  },
  deleteNews(id){
    return AuthService.delete(`/about/news/${id}`);
  },
}
export default news
